/* eslint-disable camelcase */
import { IAuthState, IFetchTokenUsingCodePayload, IRevokeTokenPayload } from './AuthModel';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ApiService from '../../services/ApiService';

import queryString from 'query-string';
import { authApiEndPoints, ssoConfig } from '../../constants/ApiEndPoints';
import { removeTokens, saveToken } from '../../utils/TokenManager';

const initialState: IAuthState = {
  error: null,
  accessTokenStatus: 'idle',
};

const fetchTokenUsingAuthCode = createAsyncThunk(
  'auth/fetchTokenUsingCode',
  async (authCode: string) => {
    const payload: IFetchTokenUsingCodePayload = {
      grant_type: 'authorization_code',
      code: authCode,
      redirect_uri: ssoConfig.callbackURL,
    };

    // Create Basic Auth token
    const credentials = btoa(`${ssoConfig.clientId}:${ssoConfig.clientSecret}`);
    const formData = queryString.stringify(payload);

    const response = await ApiService.postData(authApiEndPoints.tokenURL, {}, formData, {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Basic ${credentials}`,
    });
    return response.data;
  },
);

const revokeTokens = createAsyncThunk(
  'auth/revokeTokens',
  async (token: string) => {
    const payload: IRevokeTokenPayload = {
      token
    };

    // Create Basic Auth token
    const credentials = btoa(`${ssoConfig.clientId}:${ssoConfig.clientSecret}`);
    const formData = queryString.stringify(payload);

    const response = await ApiService.postData(authApiEndPoints.revokeURL, {}, formData, {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Basic ${credentials}`,
    });
    return response.data;
  },
);

export const AuthSlice = createSlice({
  name: 'authData',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTokenUsingAuthCode.pending, (state) => {
        state.accessTokenStatus = 'loading';
      })
      .addCase(fetchTokenUsingAuthCode.fulfilled, (state, action) => {
        state.accessTokenStatus = 'succeeded';
        saveToken(action.payload);
      })
      .addCase(fetchTokenUsingAuthCode.rejected, (state, action) => {
        state.accessTokenStatus = 'failed';
        state.error = {
          error: action?.error?.message || 'Failed to get token details',
        };
      })
      .addCase(revokeTokens.pending, (state) => {
        state.accessTokenStatus = 'loading';
      })
      .addCase(revokeTokens.fulfilled, (state) => {
        state.accessTokenStatus = 'idle';
        removeTokens();
      })
      .addCase(revokeTokens.rejected, (state, action) => {
        state.accessTokenStatus = 'idle';
        state.error = {
          error: action?.error?.message || 'Failed to logout',
        };
        removeTokens();
      });
  },
});

export default AuthSlice.reducer;
export { fetchTokenUsingAuthCode, revokeTokens };
